import { SPRest } from "../rest.js";
import { TermStore } from "./types.js";
export { TermStore, TermGroup, TermGroups, TermSets, TermSet, Relation, Relations, Term, Children, Terms, } from "./types.js";
Reflect.defineProperty(SPRest.prototype, "termStore", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return TermStore(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map